module.exports = __webpack_public_path__ + "static/media/SquareCheck.87635e0b.svg";